import styled from "styled-components";
import Body from "../typography/Body/Body";

export const StyledContainer = styled.button`
  border: none;
  cursor: pointer;
  background: none;

  .selected {
    position: relative;
  }

  .selected::after {
    content: "";
    width: 100%;
    height: 0.25rem;
    position: relative;
    left: 0;
    bottom: 1px;
    background-color: red;
  }
`;

/* Playlist video titles: 16px / 14px per design */
export const StyledTitle = styled(Body)`
  p {
    font-size: 1rem;
    line-height: 0.875rem;
  }
`;
